import { render, staticRenderFns } from "./PointInvalidation.vue?vue&type=template&id=c6930908&scoped=true"
import script from "./PointInvalidation.vue?vue&type=script&lang=js"
export * from "./PointInvalidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6930908",
  null
  
)

export default component.exports